import React from 'react';

/**
 * The app has no icon package, so feature icons are inline SVG components
 * (same convention as shared/components/ActionIcons.tsx).
 */
export type ToolPluginIconProps = {
  className?: string;
  size?: number;
};

const base = (className: string | undefined, size: number) => ({
  className,
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none' as const,
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false as const,
});

export const SearchIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <circle cx="11" cy="11" r="6.4" />
    <path d="m20 20-4.5-4.5" />
  </svg>
);

export const PlusIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <path d="M12 5.5v13M5.5 12h13" />
  </svg>
);

export const CheckIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)} strokeWidth={2.1}>
    <path d="m5 12.8 4.4 4.2L19 7.4" />
  </svg>
);

export const CloseIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)} strokeWidth={1.9}>
    <path d="m6.5 6.5 11 11M17.5 6.5l-11 11" />
  </svg>
);

export const ChevronDownIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)} strokeWidth={1.9}>
    <path d="m6.5 9.8 5.5 5 5.5-5" />
  </svg>
);

export const TrashIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <path d="M4.8 7.4h14.4" />
    <path d="M9.4 7.4V5.6h5.2v1.8" />
    <path d="M6.6 7.4l.8 11.1a1.4 1.4 0 0 0 1.4 1.3h6.4a1.4 1.4 0 0 0 1.4-1.3l.8-11.1" />
    <path d="M10.6 10.8v5.6M13.4 10.8v5.6" />
  </svg>
);

export const PencilIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <path d="M4.6 19.4h3.1l9.1-9.1-3.1-3.1-9.1 9.1Z" />
    <path d="m15.1 5.1 3.1 3.1 1.4-1.4a1.5 1.5 0 0 0 0-2.1l-1-1a1.5 1.5 0 0 0-2.1 0Z" />
  </svg>
);

export const LayersIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <path d="m12 3.6 8 4.2-8 4.2-8-4.2Z" />
    <path d="m4 12 8 4.2 8-4.2" />
    <path d="m4 16.2 8 4.2 8-4.2" />
  </svg>
);

export const AlertIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <circle cx="12" cy="12" r="8.3" />
    <path d="M12 8v4.6M12 15.8h.01" />
  </svg>
);

export const ToolboxIcon: React.FC<ToolPluginIconProps> = ({ className, size = 16 }) => (
  <svg {...base(className, size)}>
    <path d="M4 9.6h16v8.6a1.4 1.4 0 0 1-1.4 1.4H5.4A1.4 1.4 0 0 1 4 18.2Z" />
    <path d="M9 9.6V6.8a1.4 1.4 0 0 1 1.4-1.4h3.2A1.4 1.4 0 0 1 15 6.8v2.8" />
    <path d="M4 13.6h16" />
  </svg>
);
